import { useMemo } from "react";
import FirmFlowTable from "../../../../components/mytasks/FirmFlowTable";
import TeamRoleBadge from "../../../../components/teamRoles/TeamRoleBadge";
import { buildWorkloadDrilldownHref } from "../workloadDrilldownUtils";

const TeamEmployeesCell = ({ employees }) => {
    if (!Array.isArray(employees) || employees.length === 0) return "-";

    return (
        <div className="space-y-1.5">
            {employees.map((employee, index) => {
                const teamRoleName = employee?.teamRoleName?.trim();

                return (
                    <div
                        key={employee?.employeeId || index}
                        className="flex flex-wrap items-center gap-2"
                    >
                        <span>{employee?.employeeName || "-"}</span>
                        {teamRoleName && (
                            <TeamRoleBadge
                                name={teamRoleName}
                                colorHex={employee?.teamRoleColorHex}
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
};

const WorkloadReportByTeams = ({ data, appliedFilters }) => {
    const columns = useMemo(
        () => [
            {
                Header: "Team",
                accessor: "teamName",
                Cell: (props) => props.value,
            },
            {
                Header: "Department",
                accessor: "departmentName",
                Cell: (props) => props.value || "-",
            },
            {
                Header: "Employees",
                accessor: "employees",
                Cell: (props) => <TeamEmployeesCell employees={props.value} />,
            },
            {
                Header: "Total Clients",
                accessor: "totalClients",
                Cell: (props) => {
                    return (
                        <a
                            href={buildWorkloadDrilldownHref(
                                appliedFilters,
                                { teamId: props.row.original.teamId },
                            )}
                            target="_blank"
                            rel="noreferrer"
                            className="text-blue-500 hover:underline"
                        >
                            {props.value}
                        </a>
                    );
                },
            },
        ],
        [appliedFilters],
    );
    const resetSignal = appliedFilters;

    return (
        <div>
            <FirmFlowTable
                columns={columns}
                data={data}
                resetPageSignal={resetSignal}
                resetSearchSignal={resetSignal}
            />
        </div>
    );
};

export default WorkloadReportByTeams;
